import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';
import { ProjectService } from '../../../../services/project.service';
import { UiService } from '../../../../services/core.ui.service';
import { AdminService } from '../../../../services/core.admin.service';
import { GfTitleService } from '../../../../services/core.title.service';

@Component({
  selector: 'project-admin-trove',
  template: require('./project.admin.trove.html')
})
export class ProjectAdminTroveComponent implements OnInit {
  @Input() project: any;
  @Input() isProjectAdmin: any;

  options: any;
  selected: any[] = [];
  categories: any[] = [];
  selection: any = null;

  constructor(
    private projectService: ProjectService,
    private uiService: UiService,
    private adminService: AdminService,
    private titleService: GfTitleService
  ) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.project.name, 'Admin', 'Categories');
    this.options = { preventSelect: true, style: "{'padding-left':depth+'em'}" };

    this.projectService.trove(this.project.unixName)
      .then((data: any) => {
        this.selected = _.map(data.items, (item: any) => item.categories).flat();
      });

    this.adminService.troveCategories()
      .then((data: any) => {
        let items = data.items;
        // Remove root
        items = _.filter(items, (item: any) => item.id > 0);

        this.categories = _.filter(items, (item: any) => item.parentCategoryId == 0);

        this.categories.forEach((cat: any) => {
          this.setChildren(cat, items);
          cat.children = this.flatten(cat, 0);
        });
      });
  }

  private setChildren(item: any, items: any[]): void {
    item.children = [];
    _.each(items, (i: any) => {
      if (i.parentCategoryId == item.id) {
        this.setChildren(i, items);
        item.children.push(i);
      }
    });
  }

  private flatten(item: any, depth: number): any[] {
    let ret: any[] = [];
    _.each(item.children, (i: any) => {
      i.searchable = item.searchable + ' ' + i.categoryName;
      let itm = _.cloneDeep(i);
      itm.depth = depth;
      itm.label = i.categoryName;
      itm.searchable = item.searchable + ' ' + i.categoryName;
      delete itm.children;
      ret.push(itm);
      ret = ret.concat(this.flatten(i, depth + 1));
    });
    return ret;
  }

  onSelectCallback(item: any): void {
    if (item && item.id !== undefined) {
      const duplicate = this.selected.find((i: any) => i.id === item.id);
      if (!duplicate) {
        this.selected.push(item);
      }
    }
  }

  save(): void {
    const selectedIds: any[] = [];
    this.selected.forEach((item: any) => {
      selectedIds.push(item.id);
    });
    this.projectService.postTrove(this.project.unixName, selectedIds.join(','))
      .then(() => {
        this.uiService.message.showSuccess('Updated categories');
      })
      .catch(() => {
        this.uiService.message.showError('Failed to update categories');
      });
  }

  remove(item: any): void {
    this.selected = this.selected.filter((i: any) => i.id !== item.id);
  }
}
